import { Component, OnInit } from '@angular/core';
import { Preferences } from '@dep/common/user-api/types/user.type';
import { TranslocoService } from '@jsverse/transloco';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';

import { IPopup, PopupService } from '@dep/frontend/services/popup.service';
import { UserService } from '@dep/frontend/users/services/user.service';
import { UsersService } from '@dep/frontend/users/services/users.service';

@Component({
  selector: 'app-profile-manager-popup',
  templateUrl: './profile-manager.component.html',
  styleUrl: './profile-manager.component.scss',
  standalone: false,
})
export class ProfileManagerPopupComponent implements OnInit {
  public popup?: IPopup;
  public hasForwardPreference = false;
  public isLoading = false;
  public isSaving = false;

  constructor(
    private readonly logger: NGXLogger,
    private readonly popupService: PopupService,
    private readonly userService: UserService,
    private readonly usersService: UsersService,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
  ) { }

  public async ngOnInit(): Promise<void> {
    this.isLoading = true;

    // Check if the user has a forward preference.
    this.hasForwardPreference = await this.userService.hasForwardPreference(false);

    this.isLoading = false;
  }

  /**
   * Save the user preferences.
   */
  public async savePreferences(): Promise<void> {
    if (this.popup) {
      this.isSaving = true;

      const preferences = [{
        name: 'alwaysForwardToDep',
        value: this.hasForwardPreference,
        lastChanged: new Date().toISOString(),
      }] satisfies Preferences[];

      try {
        await this.usersService.updateUserProperties({ preferences });
        this.toastr.success(
          String(this.transloco.translate('START.SAVE_SUCCESS')),
          String(this.transloco.translate('START.SAVE_SUCCESS_TITLE')),
        );
      } catch (error) {
        this.logger.error('Error saving user preferences', error);
        this.toastr.error(
          String(this.transloco.translate('START.SAVE_ERROR')) + ' (' + error + ')',
          String(this.transloco.translate('START.SAVE_ERROR_TITLE')),
        );
      } finally {
        this.isSaving = false;
        this.popupService.close(this.popup.uuid);
      }
    }
  }

  /**
   * Close the popup.
   */
  public onPopupClose(): void {
    if (this.popup) {
      this.popupService.close(this.popup.uuid);
    } else {
      this.logger.error('Could not close popup because "popup" is not set', this.popup);
    }
  }
}
